module.exports = __webpack_public_path__ + "img/dosetech-logo.0a4427db.png";